/**
 * Normaliza códigos escaneados en packing (trim + minúsculas).
 */
export function normalizePackingScanCode(code: string): string {
  return code.trim().toLowerCase();
}

/** Compara dos códigos escaneados sin distinguir mayúsculas/minúsculas. */
export function packingScanCodesMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  if (a == null || b == null) return false;
  return normalizePackingScanCode(a) === normalizePackingScanCode(b);
}

/**
 * Clave única para cantidades asignadas en packing.
 * Formato: orderId:lineId:productCode
 *
 * El productCode en el tercer segmento evita colisiones cuando la API
 * devuelve el mismo line.id en varias líneas del pedido (productos distintos).
 */
export function packingAssignKey(orderId: number, lineId: number, productCode: string): string {
  return `${orderId}:${lineId}:${normalizePackingScanCode(productCode)}`;
}
